//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    routeSource: {
      type: Object,
      default: () => null
    }
  },
  computed: {
    hasInfo: function () {
      return true
    }
  }
}
